/* eslint-disable camelcase */
// Modules
import { detectShouldRun, RUN } from './modules/utils/detectShouldRun.js';
import { getSid, storeSid } from './modules/sid.js';
import { getSznaiid, storeSznaiid } from './modules/sznaiid.js';
import { getSzntime, isSzntimeValid } from './modules/szntime.js';
import { handleConsent } from './modules/consent.js';
import { sendHit } from './modules/utils/sendHit.js';

// Utils
import { debug } from './modules/utils/debug.js';

// Constants
import { ACTIONS, DEBUG_CONFIG } from './config.js';

/**
 * Initialize debug object
 */
const start = () =>
  debug({
    message: 'starting',
    state: 'start',
  });

/**
 * Sets state to 'done'
 */
const finish = () =>
  debug({
    message: 'finishing',
    state: 'done',
  });

/**
 * Retrieves and stores SID
 * Retrieves and stores consent
 * Retrieves and stores SZNAIID
 * and detects whether the library should run or not and acts in accordance.
 */
const runLinkdecoration = (handleCallback = null, consentTimeout = 5000) => {
  if (window.sznIVA && window.sznIVA[DEBUG_CONFIG.name]) {
    debug('duplicate execution - terminating');
    return;
  }

  start();

  // SID
  const sid = getSid();
  // SZNAIID
  const sznaiid = getSznaiid();
  // SZNTIME
  const szntime = getSzntime();

  // Szntime is optional:
  // - if not present, do not affect storing sznclid (SID)
  // - if present, check validity (delta time < threshold) and then decide if to save sznclid (SID) or not
  if (!szntime) {
    debug('szntime is empty or zero');
  } else if (!isSzntimeValid(szntime)) {
    debug('szntime not valid - finishing');
    finish();
    return;
  }

  // Consent
  handleConsent(window.location.href);

  if (!sid && !sznaiid) {
    debug('nothing to do - finishing');
    finish();
    return;
  }

  detectShouldRun((shouldRun) => {
    let action = null;
    if (shouldRun.result === RUN) {
      const results = [];

      if (sid) {
        results.push(storeSid(sid, shouldRun.reason));
      }

      if (sznaiid) {
        results.push(storeSznaiid(sznaiid, shouldRun.reason));
      }

      action = results.join('|');
    } else {
      if (sid) {
        // sid is present, but denied
        sendHit(ACTIONS.SID.DENIED, { reason: shouldRun.reason, ld_sid: sid, consent: shouldRun.consent }, false);
      }

      if (sznaiid) {
        // sznaiid is present, but denied
        sendHit(
          ACTIONS.SZNAIID.DENIED,
          { reason: shouldRun.reason, ld_sznaiid: sznaiid, consent: shouldRun.consent },
          false
        );
      }

      action = ACTIONS.LD_DENIED;
    }

    if (typeof handleCallback === 'function') {
      handleCallback(action);
    }
  }, consentTimeout);

  finish();
};

export { getSid, runLinkdecoration };
